import { AxiosInstance } from "axios";
import { logger } from "@platform/browser-logger";

import {
  CarrierRepDirectoryCarrierResponse,
  CarrierRepListResponse,
  CarrierRepRequest,
  CarrierRepResponse,
} from "./types";

const BP_API_BASE_URL = "/bp/v1/carrier-rep-directory";

export const listCarriers = async (
  axiosInstance: AxiosInstance,
): Promise<CarrierRepDirectoryCarrierResponse[]> => {
  const response = await axiosInstance.get<
    CarrierRepDirectoryCarrierResponse[]
  >(`${BP_API_BASE_URL}/carriers`);

  logger.debug("[Carriers Rep Directory API] Carriers listed:", {
    carrierIds: response.data.map((carrier) => carrier.id),
  });

  return response.data;
};

export const listCarrierReps = async (
  axiosInstance: AxiosInstance,
  carrierId: number,
): Promise<CarrierRepListResponse> => {
  const response = await axiosInstance.get<CarrierRepListResponse>(
    `${BP_API_BASE_URL}/carriers/${carrierId}/reps`,
  );

  logger.debug("[Carriers Rep Directory API] Carrier reps listed:", {
    carrierId,
    carrierRepIds: response.data.carrierReps.map((rep) => rep.id),
  });

  return response.data;
};

export const createCarrierRep = async (
  axiosInstance: AxiosInstance,
  carrierId: number,
  request: CarrierRepRequest,
): Promise<CarrierRepResponse> => {
  const response = await axiosInstance.post<CarrierRepResponse>(
    `${BP_API_BASE_URL}/carriers/${carrierId}/reps`,
    request,
  );

  logger.debug("[Carriers Rep Directory API] Carrier rep created:", {
    carrierId,
    carrierRepId: response.data.id,
  });

  return response.data;
};

export const updateCarrierRep = async (
  axiosInstance: AxiosInstance,
  carrierId: number,
  carrierRepId: number,
  request: CarrierRepRequest,
): Promise<CarrierRepResponse> => {
  const response = await axiosInstance.put<CarrierRepResponse>(
    `${BP_API_BASE_URL}/carriers/${carrierId}/reps/${carrierRepId}`,
    request,
  );

  logger.debug("[Carriers Rep Directory API] Carrier rep updated:", {
    carrierId,
    carrierRepId,
  });

  return response.data;
};

export const deactivateCarrierRep = async (
  axiosInstance: AxiosInstance,
  carrierId: number,
  carrierRepId: number,
): Promise<void> => {
  await axiosInstance.delete(
    `${BP_API_BASE_URL}/carriers/${carrierId}/reps/${carrierRepId}`,
  );

  logger.debug("[Carriers Rep Directory API] Carrier rep deactivated:", {
    carrierId,
    carrierRepId,
  });
};
